import { supabase } from '../providers/supabase/client';

/**
 * Get exchange rate for a specific date.
 */
export const getExchangeRateByDate = async (date) => {
    const { data, error } = await supabase
        .from('exchange_rates')
        .select('*')
        .eq('rate_date', date)
        .single();

    if (error) return null;
    return data;
};

/**
 * Get today's exchange rate.
 */
export const getTodayRate = async () => {
    const today = new Date().toISOString().split('T')[0];
    return getExchangeRateByDate(today);
};

/**
 * Get exchange rate history for a date range.
 */
export const getExchangeRateHistory = async (fromDate, toDate) => {
    const { data, error } = await supabase
        .from('exchange_rates')
        .select('*')
        .gte('rate_date', fromDate)
        .lte('rate_date', toDate)
        .order('rate_date', { ascending: false });

    if (error) {
        console.error('Error fetching exchange rate history:', error);
        return [];
    }
    return data || [];
};

// ─── Calendar Module: fetch by month, upsert, confirm ────────────────────────

export const fetchExchangeRatesByMonth = async (year, month) => {
  const startDate = `${year}-${String(month).padStart(2, '0')}-01`;
  const endDay = new Date(year, month, 0).getDate();
  const endDate = `${year}-${String(month).padStart(2, '0')}-${String(endDay).padStart(2, '0')}`;

  return await supabase
    .from('exchange_rates')
    .select('*')
    .gte('rate_date', startDate)
    .lte('rate_date', endDate)
    .order('rate_date', { ascending: true });
};

export const upsertExchangeRate = async (rateData) => {
  return await supabase
    .from('exchange_rates')
    .upsert(rateData, { onConflict: 'rate_date' })
    .select()
    .single();
};

export const confirmExchangeRate = async (id, userId) => {
  return await supabase
    .from('exchange_rates')
    .update({
      is_confirmed: true,
      confirmed_by: userId,
      confirmed_at: new Date().toISOString(),
    })
    .eq('id', id)
    .select()
    .single();
};

export const getExchangeRateForDate = async (date) => {
  const { data, error } = await supabase
    .from('exchange_rates')
    .select('*')
    .eq('rate_date', date)
    .single();

  if (data && !error) return { data, error: null };

  // Fallback: most recent rate before this date (SUNAT rule)
  const { data: fallback, error: fbError } = await supabase
    .from('exchange_rates')
    .select('*')
    .lt('rate_date', date)
    .order('rate_date', { ascending: false })
    .limit(1)
    .single();

  return { data: fallback, error: fbError };
};
